import { Alert, Snackbar } from '@mui/material';
import React, { ComponentProps } from 'react';

interface SnackbarMessageProps {
  open: boolean;
  message: string;
  severity: ComponentProps<typeof Alert>['severity'];
  onClose: () => void;
}
const SnackbarMessage = ({ open, message, severity, onClose }: SnackbarMessageProps) => (
  <Snackbar anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }} open={open} autoHideDuration={5000} onClose={() => onClose()}>
    <Alert onClose={() => onClose()} severity={severity} sx={{ width: '100%' }}>
      {message}
    </Alert>
  </Snackbar>
);

export { SnackbarMessage };
export type { SnackbarMessageProps };
